"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieFreeTrackEvent = void 0;
const RudderStackAnalyticsTracker_1 = require("./RudderStackAnalyticsTracker");
const CookieFreeTrackEvent = (eventDetails) => __awaiter(void 0, void 0, void 0, function* () {
    const { object, objectType, action, properties } = eventDetails;
    const eventOrigin = "Web";
    const eventName = `${object} ${objectType} ${action} ${eventOrigin}`;
    return yield (0, RudderStackAnalyticsTracker_1.TrackCookieFreeEvent)(eventName, properties);
});
exports.CookieFreeTrackEvent = CookieFreeTrackEvent;
//# sourceMappingURL=GenericCookieFreeEventTracker.js.map